import { useEffect, useRef, useState } from 'react';
import { fetchCallFollowUpQueueOptions } from '../CallFollowUps/callFollowUpApi';
import runGuardedRequest from '../CallFollowUps/guardedRequest';

const ASSIGNEE_SEARCH_DEBOUNCE_MS = 300;

const useAssigneeOptions = (assigneeId, refreshKey = 0) => {
  const [options, setOptions] = useState({});
  const [optionsError, setOptionsError] = useState(null);
  const optionsRequestIdRef = useRef(0);
  const assigneeSearchDebounceRef = useRef(null);

  const clearAssigneeSearchDebounce = () => {
    if (assigneeSearchDebounceRef.current) clearTimeout(assigneeSearchDebounceRef.current);
    assigneeSearchDebounceRef.current = null;
  };

  const loadOptions = (selectedAssigneeId, assigneeSearch = '') => {
    const requestId = optionsRequestIdRef.current + 1;
    optionsRequestIdRef.current = requestId;

    runGuardedRequest({
      isCurrent: () => requestId === optionsRequestIdRef.current,
      onStart: () => setOptionsError(null),
      request: () => fetchCallFollowUpQueueOptions({
        selected_assignee_id: selectedAssigneeId,
        assignee_search: assigneeSearch,
      }),
      onSuccess: (result) => setOptions(result || {}),
      onError: () => setOptionsError('Unable to load follow-up filter options. The queue is still available.'),
    });
  };

  const scheduleAssigneeSearch = (search) => {
    clearAssigneeSearchDebounce();

    assigneeSearchDebounceRef.current = setTimeout(() => {
      assigneeSearchDebounceRef.current = null;
      loadOptions(assigneeId, search);
    }, ASSIGNEE_SEARCH_DEBOUNCE_MS);
  };

  useEffect(() => {
    clearAssigneeSearchDebounce();
    loadOptions(assigneeId);

    return () => {
      clearAssigneeSearchDebounce();
      optionsRequestIdRef.current += 1;
    };
  }, [assigneeId, refreshKey]);

  return {
    options,
    optionsError,
    scheduleAssigneeSearch,
  };
};

export default useAssigneeOptions;
